import React, { Component } from 'react'
import cx from 'classnames'
import { PLACEHOLDER_IMAGE } from "../store/reducers/BookReducer"
import { connect } from 'react-redux';
import {getBookType, getControlsVisibility, getViewMode} from "../store/selectors/selectors";

class ImageFrame extends Component {
  render() {
    const {
      image,
      controlsVisibility,
    } = this.props;

    const wrapperClass = cx('image-frame', {
      'no-background': image && (image.length > PLACEHOLDER_IMAGE.length)
    }, {
      'image-frame_small' : this.props.viewMode === 'video' && this.props.isPhotoIllustratedBook,
      'slide-down': this.props.viewMode === 'video' && !controlsVisibility && this.props.isPhotoIllustratedBook
    })
    return (
      <div className={wrapperClass}>
        <img src={image} alt=""/>
      </div>
    )
  }
}



const mapStateToProps = (state) => {
  const bookType = getBookType(state);
  return {
    viewMode: getViewMode(state),
    isPhotoIllustratedBook: bookType === 'photo-illustrated book',
    controlsVisibility: getControlsVisibility(state),
  }
};

export default connect(mapStateToProps, null)(ImageFrame);



// WEBPACK FOOTER //
// ./src/components/ImageFrame.jsx